import type { AssetBank } from '../schema/assets';
import fossils from '../catalog/fossils';

export default Object.fromEntries(fossils.map((e) => [e.id, { src: 'code:fossil' } as const])) satisfies AssetBank;
